<template>

  <div style="display: inline-flex;margin-bottom: 20px;margin-top: 5px;margin-left: 5px">
    <el-select v-model="queryParam.month_range" placeholder="时间范围">
      <el-option label="过去1年 - 未来半年" value="before12_after6" />
      <el-option label="前后1年" value="before12_after12" />
      <el-option label="过去2年 - 未来1年" value="before24_after12" />
    </el-select>

    <el-radio-group v-model="queryParam.target"  style="margin-left: 20px;margin-right: 20px">
      <el-radio-button label="user" >用户</el-radio-button>
      <el-radio-button label="department" >部门</el-radio-button>
    </el-radio-group>

    <el-button @click="getKpiData" >检索</el-button>
    <FrameButton :key="calcButton.id" :button="calcButton" ></FrameButton>
  </div>

  <!---------------------------- 右上角展示kpi的颜色 ---------------------------------->
  <div style="position: absolute;top:5px;right: 5px;z-index:99;display: inline-flex;">
    <el-popover placement="bottom" :width="400" trigger="hover">
      <template #reference>
        <el-button style="margin-right: 16px">查看KPI项目</el-button>
      </template>
      <div style="display: flex;flex-wrap: wrap;padding: 5px;border: 1px solid lightgray;" width="100%">
        <div v-for="kpiItem in kpiItems" class="kpiTip" :style="'color: ' + kpiItem.color + ';background-color: ' + kpiItem.bg_color">{{kpiItem.name}}</div>
      </div>
    </el-popover>

  </div>

  <el-table :data="kpiList" stripe style="width: 100%;height: 90%">
    <el-table-column prop="name" label="用户/部门" width="100" fixed="left"/>
    <el-table-column v-for="month in monthList" :label="month" width="155" align="center">
      <template #default="scope">
        <div style="display: inline-flex;margin-bottom: 3px;font-size: larger" v-for="kpi in scope.row[month]" width="100%">
          <div class="goal_value_class" :style="'color: ' + kpi.color + ';background-color: ' + kpi.bg_color" >{{kpi.goal_value}}</div>
          <div class="goal_rate_class" :style="'background-color: ' + getFinishRateColor(kpi.finish_rate)">{{kpi.finish_rate}}%</div>
        </div>

        <div style="width: 140px;text-align: center;display: block">
          <el-icon size="small" @click="showEditDialog(scope.row,month)" >
            <ElIconEdit />
          </el-icon>
        </div>
      </template>
    </el-table-column>
  </el-table>

  <!---------------------------- 编辑对话框 ---------------------------------->
  <el-dialog title="编辑KPI目标" v-model="editDialogVisible" :close-on-click-modal="false" width="800px"
             style="--el-font-size-base: 12px">
    <div>
      <el-form v-model="currentKpiData" label-width="200px" style="margin-right: 100px;">
        <el-form-item label="用户" v-if="'user' == currentKpiData.target" style="width: 100%">
          <el-input v-model="currentKpiData.name" readonly placeholder="用户"></el-input>
        </el-form-item>
        <el-form-item label="部门" v-if="'department' == currentKpiData.target" style="width: 100%">
          <el-input v-model="currentKpiData.name" readonly placeholder="部门"></el-input>
        </el-form-item>
        <el-form-item label="年月" style="width: 100%">
          <el-input v-model="currentKpiData.month" readonly placeholder="年月"></el-input>
        </el-form-item>

        <div style="height: 290px;overflow-y: auto">
          <el-row style="margin-right: 10px;">
            <el-col :span="12" v-for="(kpiItem,index) in currentKpiData.kpiList">
              <el-form-item :label="kpiItem.name" style="width: 100%" v-if="index%2 == 0">
                <el-input-number v-model="kpiItem.goal_value" placeholder="KPI目标值" controls-position="right"></el-input-number>
              </el-form-item>
              <el-form-item :label="kpiItem.name" style="width: 100%" v-if="index%2 == 1">
                <el-input-number v-model="kpiItem.goal_value" placeholder="KPI目标值" controls-position="right"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>

        </div>

      </el-form>
      <el-button @click="saveKpiGoal()" type="primary" style="font-size: 13px;position: inherit;margin-left: 200px;width: 460px;margin-top: 10px">保存</el-button>
    </div>
  </el-dialog>

</template>


<script>

export default {
  name: "KpiGoalManage",
  provide() {
    return {
      $fn: {
        reload: () => {
          this.getKpiData();
        }
      }
    }
  },
  data() {
    return {
      queryParam: {month_range: 'before12_after6', target: 'user'},
      editDialogVisible: false,
      currentKpiData:{},
      currentMonth:'',
      kpiItems: [{id:'sales_amount', name:'销售额(万)', color:'lightblue'},{id:'sw_cnt', name:'SW套数', color:'lightgreen'},{id:'pdm_cnt', name:'PDM套数', color:'yellow'}],
      monthList: ['2023-08','2023-07','2023-06','2023-05','2023-04','2023-03','2023-02','2023-01','2022-12','2022-11','2022-10','2022-09'],
      kpiList: [],
      calcButton:{
        "component": "button",
        "label":"KPI结果计算",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "crm_kpi_calc","title":"KPI结果计算","width":400,"height":250}
      },
    }
  },
  methods: {
    showEditDialog(tableRow, month){
      this.editDialogVisible = true;
      this.currentKpiData = Object.assign(tableRow);
      this.currentKpiData.month = month;

      var kpiList = []
      for(var kpiItem of this.kpiItems){
        var kpiNew = Object.assign(kpiItem)
        kpiNew.kpi_item_id = kpiNew.id
        kpiNew.goal_value = 0

        for(var existItem of tableRow[month]){
          if(kpiNew.kpi_item_id == existItem.kpi_item_id){
            kpiNew.goal_value = existItem.goal_value;
          }
        }

        kpiList.push(kpiNew)
      }

      this.currentKpiData.kpiList = kpiList
    },
    async getKpiData() {
      //查询数据
      let rtn = await this.$http('crmKpiService.getKpi', this.queryParam)
      if(!rtn || !rtn.month_list){
        return this.$message.error("返回的数据格式不正确")
      }

      //赋值
      this.monthList = rtn.month_list;
      this.kpiList = rtn.kpi_list;

    },
    async getKpiItems() {
      //查询数据
      this.kpiItems = await this.$http('crmKpiService.getKpiItems')
    },
    async saveKpiGoal() {
      await this.$http('crmKpiService.saveKpiGoal', this.currentKpiData)
      this.$message.success("保存成功")
      this.editDialogVisible = false;
      this.getKpiData();
    },
    getFinishRateColor(finish_rate) {
      if(finish_rate <=60){
        return '#ff9933'
      }

      if(finish_rate <=80){
        return '#66ffff'
      }

      return '#33ff66'
    }
  },
  mounted() {
    this.getKpiItems();
    this.getKpiData()
  }
}
</script>


<style lang="less" scoped>
@import 'src/global';

.myContainer {
  padding: 5px;
}

.baidu-map-view{
  width: 100%;
  height: 100%;
}

.goal_rate_class {
  border: 1px solid lightgray;
  padding: 3px;
  width: 70px;
  text-align: center
}

.goal_value_class {
  padding: 3px;
  width: 70px;
  text-align: center
}


.kpiTip{
  height: 30px;
  line-height: 30px;
  padding: 0px 10px 0px 10px ;
  text-align: center;
  width: 170px;
  display: block;
  margin-left: 3px;
  margin-right: 8px;
  margin-bottom: 8px;

}

</style>
